
import { Box } from '@mui/system';
import '../App.css';
import { BackButton, BackgroundStyle, BigHeading, BlueButton, LightBlueContainer, LongBlueButton, ShortBlueButton } from '../assets/style';
import MainContent from '../components/MainContent';
import { contractPageName } from '../components/PageName';
import { useLocation, useNavigate } from 'react-router-dom';
import FormLabel from '../components/FormLabel';
import { useEffect } from 'react';
import { useLazyGetContractByIdQuery } from '../features/contract/ContractSlice';
import { useTranslation } from "react-i18next";
import RecordTable from '../components/RecordTable';
import { useSelector } from 'react-redux';
import { selectPermissions } from '../features/auth/authSlice';
import { Permissions } from '../utils/Permissions';

const ContractDetailPage = () => {
    const { t, i18n } = useTranslation();
    const getLocation = useLocation();
    const [getContractById, contractById] = useLazyGetContractByIdQuery();
    const permissions = useSelector(selectPermissions)

    const navigate = useNavigate()

    const handleEditOnClick: React.MouseEventHandler<HTMLButtonElement> = function (e) {
        navigate("/edit-contract", { state: getLocation?.state })
    }

    useEffect(() => {
        try {
            getContractById(getLocation?.state)
        } catch (error) {

        }
    }, [])

    useEffect(() => {
        console.log(contractById);
    }, [contractById])

    return (
        <MainContent type={contractPageName}>
            <BackgroundStyle sx={{ zIndex: 0 }}>
                <LightBlueContainer>
                    <Box sx={{ display: "row" }}>
                        <BigHeading>{t("Contract Detail")}</BigHeading>
                        {
                            permissions.includes(Permissions.ContractEdit)
                            && <ShortBlueButton onClick={handleEditOnClick}>{t("Edit")}</ShortBlueButton>
                        }
                    </Box>

                    <FormLabel title={t("Contract No.")} value={contractById?.data?.number} />
                    <FormLabel title={t("Contract Title")} value={contractById?.data?.title} />
                    <FormLabel title={t("Start Date")} value={contractById?.data?.startDate} />
                    <FormLabel title={t("End Date")} value={contractById?.data?.endDate} />
                    <FormLabel title={t("Remark")} value={contractById?.data?.remark} />
                    &nbsp;

                    <FormLabel title={t("Contract Inspector")} value={<></>} />
                    <RecordTable
                        columns={[
                            { field: 'name', headerName: t('Name'), width: 200, isSortable: true },
                            { field: 'email', headerName: t('Email'), width: 200, isSortable: true },
                            { field: 'companyName', headerName: t('Company Name'), width: 300, isSortable: true },
                            { field: 'roleName', headerName: t('Role Name'), width: 300, isSortable: false },
                        ]}
                        rows={contractById?.data?.inspectors}
                        checkbox={false}
                        deleteButton={false}
                    />

                    <Box sx={{ display: "row" }}>
                        {
                            permissions.includes(Permissions.ProjectEdit)
                            && <LongBlueButton onClick={() => { navigate('/add-project', { state: { contract: getLocation?.state } }) }}>{t("Create Project")}</LongBlueButton>
                        }
                        <BackButton onClick={() => { navigate('/contract') }}>{t("Back")}</BackButton>
                    </Box>
                    &nbsp;
                </LightBlueContainer>
            </BackgroundStyle>
        </MainContent>
    );
};

export default ContractDetailPage;